import { globalSettings } from "app/_services/GlobalSettings/globalSettingsServices";
import MainBreadcrumb from "app/views/custom/components/MainBreadcrumb";
import React, { useEffect, useMemo, useState } from "react";
import { Button, Col, Modal, OverlayTrigger, Row, Tooltip } from "react-bootstrap";
import { smtpInitialFormJson, smtpRules } from "./Constant";
import { Validation } from "app/_helpers/validation/Validation";
import toastr from "toastr";
import { BsFillInfoCircleFill } from "react-icons/bs";
import { CommmonService } from "app/_services/CommonService/CommonService";

const SmtpDetails = () => {
  const [smtpForm, setSmtpForm] = useState([]);
  const [errorForm, setErrorForm] = useState({});
  const [defaultSmtp, setDefaultSmtp] = useState({});
  const [showManageModal, setShowManageModal] = useState(false);

  const getSmtpDetails = async () => {
    let response = await globalSettings.globalAllSettings(`?smtp=${true}`);
    if (response && response.data && response.data.global_settings) {
      setSmtpForm(response.data.global_settings);
    }
  };

  const getDefaultSmtpDetails = async () => {
    let response = await CommmonService.getDefaultSmtp();
    if (!response?.status) return;
    setDefaultSmtp(response?.data);
  };

  useEffect(() => {
    getSmtpDetails();
    getDefaultSmtpDetails();
  }, []);

  const onChange = ({ target: { name, value } }) => {
    setSmtpForm((prev) => {
      return prev?.map((d) => {
        return d?.metaKey === name ? { ...d, metaValue: value } : d;
      });
    });
  };

  let finalSmtpForm = useMemo(() => {
    let smtpObjJosn = { ...smtpInitialFormJson };
    smtpForm.forEach((obj) => {
      smtpObjJosn[obj?.metaKey] = { ...smtpObjJosn[obj?.metaKey], value: obj?.metaValue };
    });
    return smtpObjJosn;
  }, [smtpForm]);

  const onSubmit = async () => {
    let validateForm = {};
    Object.keys(finalSmtpForm).forEach((key) => {
      validateForm[key] = finalSmtpForm[key]?.value;
    });
    const errorObj = Validation(validateForm, smtpRules);
    setErrorForm(errorObj);
    if (Object.values(errorObj).filter((d) => d !== "").length) return;

    const response = await globalSettings.updateGlobalSetting({
      globalSettings: smtpForm,
    });
    if (!response?.status) {
      toastr.error(response?.message);
      return;
    }
    toastr.success(response?.message || "Updated successfully");
    getSmtpDetails();
  };

  return (
    <div>
      <MainBreadcrumb
        routeSegments={[
          { name: "Admin Panel", path: "#" },
          { name: "SMTP Details", path: "#" },
        ]}
        breadCrumbsText="User_Management_User_Registration"
      />

      <div className="healthSafetyEnvironmentWrapper">
        <div className="p-2">
          <div className="card p-3 mt-3">
            <div className="simple-card-title">
              <h3 className="text-capitalize mb-1">
                SMTP Details{" "}
                <OverlayTrigger
                  placement="top"
                  overlay={<Tooltip id="tooltip-top">Default SMTP Details</Tooltip>}
                >
                  <span
                    className="icons"
                    onClick={() => {
                      setShowManageModal(true);
                    }}
                  >
                    <BsFillInfoCircleFill />
                  </span>
                </OverlayTrigger>
              </h3>
            </div>
            <div className="ehsFormWrapper">
              <Row>
                {Object?.keys(finalSmtpForm)?.map((key) => {
                  return (
                    <Col lg={finalSmtpForm[key]?.lg}>
                      <div className="form-group viewbox">
                        <h5 className="w-500 mb-1">{key}</h5>
                        <input
                          value={finalSmtpForm[key]?.value}
                          name={key}
                          onChange={onChange}
                          class="form-control"
                          type={finalSmtpForm[key]?.type}
                        />
                        <span className="small text-danger">{errorForm?.[key]}</span>
                      </div>
                    </Col>
                  );
                })}
              </Row>
              <div className="mb-2 mt-3 text-center">
                <Button
                  onClick={onSubmit}
                  type="submit"
                  variant="primary"
                  className="m-1 text-capitalize"
                >
                  Save
                </Button>
              </div>
            </div>
          </div>
        </div>
      </div>
      <Modal show={showManageModal} onHide={() => setShowManageModal(false)} size="lg">
        <div className="card" style={{ overflow: "visible" }}>
          <div className="card-body">
            <div className="simple-card-title">
              <h3 className="text-capitalize mb-1">{`Default SMTP Details`}</h3>
            </div>
            <div className="ehsFormWrapper">
              <Row>
                {Object?.keys(smtpInitialFormJson)?.map((key) => {
                  return (
                    <Col lg={smtpInitialFormJson[key]?.lg}>
                      <div className="form-group viewbox">
                        <h5 className="w-500 mb-1">{key}</h5>
                        <input
                          value={defaultSmtp?.[key]}
                          name={key}
                          class="form-control"
                          type={smtpInitialFormJson[key]?.type}
                          readOnly
                        />
                      </div>
                    </Col>
                  );
                })}
              </Row>
            </div>
            <div className="mt-2 text-center">
              <Button
                onClick={() => {
                  setShowManageModal(false);
                }}
                className="btn btn-secondary mr-2"
              >
                Close
              </Button>
            </div>
          </div>
        </div>
      </Modal>
    </div>
  );
};

export default SmtpDetails;
